module.exports = __webpack_public_path__ + "static/media/intro-desktop-zh-CN.912a2e78.png";